/* eslint-disable array-bracket-newline */
import { Address } from '@multiversx/sdk-core/out';
import axios from 'axios';
import { GetPairResult } from '../interfaces/elrondInterfaces/getPairResult';
import { NetworkConfigResult } from '../interfaces/elrondInterfaces/networkConfigResult';
import { NonceResult } from '../interfaces/elrondInterfaces/nonceResult';
import { TxSendResult } from '../interfaces/elrondInterfaces/txSend';
import { base64ToHex, isAddressZero, toHex } from './elrondConverters';
import {
  GetTxResult,
  GetTxStatus,
} from '../interfaces/elrondInterfaces/getTxResult';

// const { ExtensionLoginButton } = DappUI;
export const EGLD = 'EGLD';

/**
 * In order to fix wallet switch I have to copy config from NFT stores
 */
const customNetworkConfig = {
  id: 'mainnet',
  name: 'Mainnet',
  egldLabel: 'EGLD',
  walletAddress: 'https://wallet.multiversx.com',
  apiAddress: 'https://api.multiversx.com',
  explorerAddress: 'https://explorer.multiversx.com',
  walletConnectBridgeAddresses: [
    'https://wallet-connect-fra-sock.elrond.com/wallet-connect-0?env=browser&host=app.kattana.io&protocol=wc&version=1',
    'https://wallet-connect-fra-sock.elrond.com/wallet-connect-7?env=browser&host=app.kattana.io&protocol=wc&version=1',
  ],
  egldDenomination: '18',
  decimals: '4',
  gasPerDataByte: '1500',
  walletConnectDeepLink:
    'https://maiar.page.link/?apn=com.elrond.maiar.wallet&isi=1519405832&ibi=com.elrond.maiar.wallet&link=https://maiar.com/',
  apiTimeout: '10000',
};

const mainnet = {
  environment: 'mainnet',
  chainID: '1',
  completedTransactionsDelay: 500,
  api: 'https://api.multiversx.com',
  exchangeGraph: 'https://graph.xexchange.com/graphql',
  gateway: 'https://gateway.multiversx.com',
  wrapEgld: 'erd1qqqqqqqqqqqqqpgqhe8t5jewej70zupmh44jurgn29psua5l2jps3ntjj3',
  egld: 'WEGLD-bd4d79',
};

const testnet = {
  environment: 'testnet',
  chainID: 'T',
  api: 'https://testnet-api.elrond.com',
  gateway: 'https://testnet-gateway.elrond.com',
  wrapEgld: 'erd1qqqqqqqqqqqqqpgqhjdqy6rqz3vdqsr3wydvyha9xvw5n75h0n4swc0wnt', // wrap egld address
  egld: 'WEGLD-71e90a', // wrapped egld,
};

export const Configuration = mainnet;
export const MinGasLimit = 50000;

export const getNonce = async (userAddress: string): Promise<number> => {
  const url = `${Configuration.gateway}/address/${userAddress}/nonce`;
  const result = await axios.get<NonceResult>(url);

  return result.data.data.nonce;
};

export const getNetworkConfig = async (): Promise<NetworkConfigResult> => {
  const url = `${Configuration.gateway}/network/config`;
  const { data: result } = await axios.get<NetworkConfigResult>(url);

  return result;
};

export const getPair = async (tokenA: string, tokenB: string): Promise<any> => {
  const url = `${Configuration.gateway}/vm-values/query`;
  const tokenAHex = toHex(tokenA);
  const tokenBHex = toHex(tokenB);

  const body = {
    scAddress: 'erd1qqqqqqqqqqqqqpgqq66xk9gfr4esuhem3jru86wg5hvp33a62jps2fy57p', // address of the xExchange factory
    funcName: 'getPair',
    args: [tokenAHex, tokenBHex],
  };

  const { data: result } = await axios.post<GetPairResult>(url, body);
  const pairAddressHex = base64ToHex(result.data.data.returnData[0]);
  if (isAddressZero(pairAddressHex)) {
    // not found such pair to swap
    // todo something
  }
  const pairAddress = Address.fromHex(pairAddressHex);
  console.log({ pairAddress });

  return pairAddress.toString();
};

export const sendTransaction = async (tx: any): Promise<TxSendResult> => {
  const url = `${Configuration.gateway}/transaction/send`;
  const { data: result } = await axios.post<TxSendResult>(url, tx);

  return result;
};

export const getTransaction = async (txHash: string): Promise<GetTxResult> => {
  const url = `${Configuration.gateway}/transaction/${txHash}`;
  const { data: result } = await axios.get<GetTxResult>(url);

  return result;
};

export const getTransactionStatus = async (
  txHash: string
): Promise<GetTxStatus> => {
  const url = `${Configuration.gateway}/transaction/${txHash}/status`;
  const { data: result } = await axios.get<GetTxStatus>(url);

  return result;
};
